export default __webpack_public_path__ + "static/main-image-923d02d98f8368bc198f4fdf94828f82.png";